import React, { useState } from "react";
import PropTypes from "prop-types";
import LockIcon from "../../assets/padlock.svg";
import { HiLocationMarker } from "react-icons/hi";
import {
  RegisterNewAddress,
  ConfirmAndCancel,
} from "./styles";

import { swalCustom } from "../../utils/functions";

import AddressComponent from "../../components/AddressComponent";
import ModalApp from "../../components/ModalApp";
import FixedAddressModal from "./FixedAddressModal";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import {
  isFixedAddress,
  isMainAddress,
  normalizeAddressFromApi,
  SAFRA_FIXED_ADDRESS_MESSAGE,
} from "./addressUtils";
import notify from "../UI/toast";
import { capitalizeFirstLetter } from "../../extension/string.ts";

export default function PersonalAddressList({
  addresses,
  onClickDelAddress,
  setAddress,
  setOpen,
  address,
  open,
  handleEndereco,
  screenName = "minha-conta",
}) {
  const [showFixedModal, setShowFixedModal] = useState(false);

  const handleDeleteAddress = (addressItem) => {
    if (isFixedAddress(addressItem)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    trackClick({
      title: "excluir",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    swalCustom
      .fire({
        html: '<p class="fw-bold fs-5 mb-0">Deseja excluir este endereço?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "question",
      })
      .then((result) => {
        if (result.isConfirmed) {
          onClickDelAddress(addressItem.uuid);
        } else if (result.dismiss) {
          trackClick({
            title: "cancelar-exclusao-endereco",
            contentType: "atualizar-dados-do-endereco",
            screenName,
            tagId: tagIdFromLegacySuffix("07"),
          });
        }
      });
  };

  const editarEndereco = (addressItem) => {
    if (isFixedAddress(addressItem)) {
      notify(SAFRA_FIXED_ADDRESS_MESSAGE, "info");
      return;
    }

    trackClick({
      title: "alterar",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    setAddress(addressItem);
    setOpen(true);
  };

  return (
    <>
      <ModalApp
        show={open}
        handleModal={() => {
          trackClick({
            title: "fechar-modal",
            contentType: "cadastrar-novo-endereco",
            screenName,
            tagId: tagIdFromLegacySuffix("07"),
          });
          setOpen(false);
        }}
      >
        <AddressComponent
          onConfirm={handleEndereco}
          onCancel={() => setOpen(false)}
          address={address}
        />
      </ModalApp>
      <RegisterNewAddress>
        {addresses.length > 0 ? (
          [...addresses]
            .map(normalizeAddressFromApi)
            .sort((a, b) => {
              const aFixed = isFixedAddress(a) ? 1 : 0;
              const bFixed = isFixedAddress(b) ? 1 : 0;
              if (bFixed !== aFixed) return bFixed - aFixed;
              return Number(isMainAddress(b)) - Number(isMainAddress(a));
            })
            .map((addressItem, index) => {
              const fixed = isFixedAddress(addressItem);

              return (
                <div key={addressItem.uuid || index} style={{ marginBottom: !fixed ? "32px" : undefined }}>
                  <div className="registerNewAddressHeader">
                    <p className="mb-0 d-flex align-items-center gap-2" style={{
                      color: "rgba(0, 0, 60, 0.60)",
                      fontFamily: "var(--font-family)",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      lineHeight: "150%",
                    }}>
                      {capitalizeFirstLetter(addressItem.label || "Principal")}
                      {fixed && <HiLocationMarker color="black" />}
                      {isMainAddress(addressItem) && (
                        <span className="address-principal-badge">Principal</span>
                      )}
                    </p>
                    <ConfirmAndCancel>
                      {!fixed && (
                        <>
                          <button
                            className="text-decoration-underline text-xs default-button"
                            onClick={() => editarEndereco(addressItem)}
                            type="button"
                          >
                            ALTERAR
                          </button>
                          <button
                            className="btn link-cancel-wl text-decoration-underline text-xs"
                            onClick={() => handleDeleteAddress(addressItem)}
                            type="button"
                          >
                            REMOVER
                          </button>
                        </>
                      )}
                    </ConfirmAndCancel>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ width: "95%", marginTop: "24px" }}
                  >
                    <div className="information text-justify font-wl-400 text-mg">
                      <span>
                        {addressItem.streetName}, {addressItem.number}
                      </span>
                      <span>
                        {addressItem.neighborhood}
                        {addressItem.complement ? `, ${addressItem.complement}` : ""}
                      </span>
                      <span>
                        {addressItem.city}, {addressItem.state} - {addressItem.zipCode}
                      </span>
                    </div>
                  </div>
                  {fixed && (
                    <div style={{ width: "100%", marginTop: "24px", marginBottom: "32px" }}>
                      <p style={{
                        color: "var(--primary-color)",
                        fontFamily: "var(--font-family)",
                        fontSize: "12px",
                        fontStyle: "italic",
                        fontWeight: 400,
                        lineHeight: "150%",
                        marginBottom: "0",
                      }}>
                        {SAFRA_FIXED_ADDRESS_MESSAGE}
                      </p>
                    </div>
                  )}
                </div>
              );
            })
        ) : (
          <span className="information">Nenhum endereço cadastrado</span>
        )}
      </RegisterNewAddress>
      <FixedAddressModal
        show={showFixedModal}
        onClose={() => setShowFixedModal(false)}
      />
    </>
  );
}

PersonalAddressList.propTypes = {
  addresses: PropTypes.array,
  onClickDelAddress: PropTypes.func,
  setAddress: PropTypes.func,
  setOpen: PropTypes.func,
  address: PropTypes.object,
  open: PropTypes.bool,
  handleEndereco: PropTypes.func,
  screenName: PropTypes.string,
};
